import { useQuery } from '@tanstack/react-query';

import { ReactNode } from 'react';

import { Box } from '@mui/material';

import { useApiClient, useHasPermission } from '@@common';

import { AgentClient } from '../../api/api';
import { Permissions } from '../../common/Permissions';
import AgentAvatar from '../../views/Agents/AgentAvatar';

export default function ChatAgentAvatar({
	agentId,
	size = 24,
	fallback,
	headerPortrait = false,
}: {
	agentId: string;
	size?: number;
	fallback: ReactNode;
	headerPortrait?: boolean;
}) {
	const client = useApiClient(AgentClient);
	const canReadAgents = useHasPermission(Permissions.AgentRead);
	const canReadFiles = useHasPermission(Permissions.FileRead);
	const canReadAvatar = canReadAgents && canReadFiles;
	const { data: agent } = useQuery({
		queryKey: ['agent-picker-by-id', agentId.toLowerCase()],
		queryFn: () => client.getAgent(agentId),
		enabled: canReadAvatar,
		staleTime: 60_000,
		retry: false,
	});
	if (!canReadAvatar || !agent?.fileId) {
		return <>{fallback}</>;
	}
	const avatar = <AgentAvatar name={agent.name} fileId={agent.fileId} size={size} variant="rounded" cutout={headerPortrait} fallback={fallback} />;
	return headerPortrait ? (
		<Box
			className="chat-header-portrait"
			data-testid="chat-header-portrait"
			sx={{ width: size, height: size + 6, py: '3px', boxSizing: 'content-box', display: 'flex', alignItems: 'center', flexShrink: 0, overflow: 'visible' }}
		>
			{avatar}
		</Box>
	) : (
		avatar
	);
}
